import styled, { css } from 'styled-components'
import Colors from 'builder/styles/colors'
import { Icon20 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'

import NoResumeImg from './assets/noResume.png'

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral15};
  background: ${Colors.White};
`

export const ActionText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`

export const ActionCredit = styled.p`
  ${Typography.Body}
  ${FontWeights.DemiBold}

  color: ${Colors.Green50};
`

export const IlustrationContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
`

export const ImageContainer = styled.div<{ $isPreview?: boolean }>`
  width: 100%;
  height: 100%;

  ${({ $isPreview }) =>
    $isPreview &&
    css`
      padding-top: 40px;
      padding-left: 32px;
      padding-right: 96px;
    `}
`

export const Image = styled.div<{ $src?: string }>`
  width: 100%;
  height: 100%;
  background-image: url(${({ $src }) => $src || NoResumeImg});
  background-size: ${({ $src }) => ($src ? 'cover' : 'contain')};
  background-position: center;
  background-repeat: no-repeat;
`

export const ScoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 64px;
  position: absolute;
  top: 42px;
  right: 20px;
`

export const ScoreText = styled.p`
  ${Typography.Caption}
  ${FontWeights.Medium}

  color: ${Colors.Blue80};
`

export const Score = styled.div<{ $background: string }>`
  padding: 2px 4px 2px 6px;
  border-radius: 8px;

  width: fit-content;

  ${Typography.Body}
  ${FontWeights.DemiBold}
  color: ${Colors.White};

  ${({ $background }) => css`
    background: ${$background};
  `}
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const Icon = styled(Icon20.ChevronRightRegular)`
  color: ${Colors.Neutral80};
`
